import { List, Radio, Skeleton } from 'antd';
import { CheckOutlined } from '@ant-design/icons'; // ⬅️ thêm icon check
import { InfiniteScroll } from 'components/common';
import { useLazyOrganizationUnitChildren } from 'hooks';
import { useEffect } from 'react';

type TransferTeamTreeProps = {
  organizationUnitId: number;
  selectedId: number | null;
  onSelect: (id: number) => void;
};

const TransferTeamTree = ({ organizationUnitId, selectedId, onSelect }: TransferTeamTreeProps) => {
  const { fetchData, organizationsUnits, isLoading, hasMore, handleLoadMore } = useLazyOrganizationUnitChildren();

  useEffect(() => {
    fetchData({ organizationUnitId });
  }, [organizationUnitId]);

  return (
    <InfiniteScroll
      isLoading={Boolean(isLoading)}
      next={handleLoadMore}
      hasMore={Boolean(hasMore)}
      loader={<Skeleton active title={false} paragraph={{ rows: 3 }} />}
      endMessage={<p></p>}
    >
      <Radio.Group
        value={selectedId}
        onChange={(e) => onSelect(e.target.value)}
        className="w-full space-y-1"
      >
        <List
          split={false}
          dataSource={organizationsUnits}
          rowKey={(item) => item.organizationUnitId}
          renderItem={(item) => {
            const isSelected = selectedId === item.organizationUnitId;
            return (
              <List.Item
                className={`flex items-center rounded-md px-3 py-2 transition-all duration-150 ${
                  isSelected
                    ? 'border border-blue-500 bg-blue-50 shadow-sm'
                    : 'border border-transparent hover:bg-gray-50'
                }`}
              >
                <Radio value={item.organizationUnitId}>
                  <span className="flex items-center gap-4">
                    {item.name}
                    {isSelected && <CheckOutlined className="text-blue-500" />}
                  </span>
                </Radio>
              </List.Item>
            );
          }}
        />
      </Radio.Group>
    </InfiniteScroll>
  );
};

export default TransferTeamTree;
